import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_AD_UNIT_PREBID_STACK: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnitPrebidStack($input: UpdateAdUnitPrebidStackInput!) {
    updateAdUnitPrebidStack(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
